import "./core/feature-flags";
import "./assets/styles/global.scss";
import { LabelStudio } from "./LabelStudio";

window.LabelStudio = LabelStudio;

export default LabelStudio;

// Attach to global for browsers
if (typeof window !== 'undefined') {
    window.LabelStudio = LabelStudio;
  }
  
// UMD default export
module.exports = LabelStudio; // ← This line is key for UMD to work correctly

export { LabelStudio };
